<!-- =========================================================================================
    File Name: UploadAutomatic.vue
    Description: Uploading files automatically
    ----------------------------------------------------------------------------------------
    Lighthouse - Cloudify Admin Panel
========================================================================================== -->

<template>
  <div>
    <vx-card v-if="convertOn === false">
      <h2 bg-color="primary">You have not activated this extension. <br />To activate this extension please contact support.</h2>
    </vx-card>
    <vx-card v-else :title="title">
      <p class="mb-3">{{ subtitle }}</p>
      <div class="flex">
        <vs-button :color="selectedFile.color" type="border" @click="triggerFileInput">
          <span class="text-base leading-normal">{{ selectedFile.name }}</span>
          <input type="file" id="file" ref="file" @change="handleFileSection()" class="hidden" />
        </vs-button>
        <vs-button v-if="!fileUrl && selectedFile.name !== 'Select File'" class="submit-btn ml-4 px-2 py-2" color="primary" type="filled" @click="submitFile()"
          >Upload</vs-button
        >
        <vs-button v-if="fileUrl" class="submit-btn ml-4 px-6 py-4" color="danger" type="filled" v-on:click="submitToRemoteHandler()">Run Workflow</vs-button>
      </div>
    </vx-card>
    <vs-popup class="holamundo" title="Extension not activated for this account" @close="convertOn = false" :active.sync="popupActive">
      <p>To activate this Extension either schedule a meeting or complete purchase in marketplace</p>
    </vs-popup>
    <vs-popup class="holamundo" title="Workflow Summary" @close="$router.go()" :active.sync="workflowSubmitted">
      <p>You have run your workflow successfully</p>
    </vs-popup>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
const axios = require('axios').default

export default {
  name: 'ConvertComponent',
  data() {
    return {
      file: '',
      hitUrl: '',
      fileUrl: '',
      selectedFile: { name: 'Select File', color: 'primary' },
      popupActive: false,
      convertOn: true,
      title: 'Upload a file to run workflow',
      subtitle: 'Your file will be passed through automation',
      workflowSubmitted: false,
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.file.click()
    },
    // this method is reponsible for fetching extension details for the user.
    async fetchAndAssignFirestore() {
      if (JSON.parse(localStorage.getItem('userInfo'))) {
        const Extensions = this.$store.state.DB.extensions
        if (Extensions && Extensions.convert) {
          this.convertOn = true
          this.popupActive = false
          this.title = Extensions.convert.title
          this.subtitle = Extensions.convert.subtitle
          this.hitUrl = Extensions.convert.url
        } else {
          this.popupActive = true
          this.convertOn = false
        }
      }
    },
    // this method updates the vue file vairable with the metadata of the file that the user has selected for upload
    handleFileSection() {
      this.file = this.$refs.file.files[0]
      this.selectedFile.color = 'warning'
      this.selectedFile.name = this.file.name
    },
    // this method is for uploading file to firebase storage
    async submitFile() {
      this.$vs.loading()
      try {
        // firebase doesn't allow files to be uploaded with same name. IT WILL OVERWRITE. To prevent this I prefixed the timestamp to file name to make it somewhat unique.
        const uniqueFileName = `${new Date().getTime()}_${this.file.name}`
        const storageRef = firebase.storage().ref()
        const fileRef = storageRef.child(`cloudifyConvert/${JSON.parse(localStorage.getItem('userInfo')).uid}/${uniqueFileName}`)
        await fileRef.put(this.file)
        this.fileUrl = await fileRef.getDownloadURL()
        // reset the select file input section after successful upload
        this.selectedFile.color = 'success'
        this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'File is uploaded successfully' })
      } catch (err) {
        this.$vs.notify({
          title: 'Error Occured',
          text: err.message,
          color: 'danger',
        })
      }
      this.$vs.loading.close()
    },
    // this function is used to send downloadURL (from firebase storage) to target endpont
    async submitToRemoteHandler() {
      try {
        if (this.hitUrl) {
          this.$vs.loading()
          const runworkflow = await axios.post(
            `${this.hitUrl}`,
            {
              name: this.file.name,
              url: this.fileUrl,
            },
            {
              headers: {
                'Content-Type': this.hitUrl.match(/zapier/i) ? 'application/x-www-form-urlencoded; charset=UTF-8' : 'application/json; charset=UTF-8',
              },
            }
          )
          this.$vs.notify({
            title: 'Workflow Executed Successfully',
            text: runworkflow.data,
            color: 'success',
          })
          this.workflowSubmitted = true
          this.selectedFile.color = 'primary'
          this.fileUrl = ''
        } else throw 'Endpoint Missing'
        this.$vs.loading.close()
        this.selectedFile.name = 'Select File'
      } catch (err) {
        this.$vs.notify({
          title: 'Error Occured',
          text: err,
          color: 'danger',
        })
      }
      this.$vs.loading.close()
    },
  },
  async created() {
    setTimeout(async () => {
      await this.fetchAndAssignFirestore()
    }, 2500)
  },
}
</script>

<style scoped></style>
